import { render, staticRenderFns } from "./DeleteRewardModal.vue?vue&type=template&id=1a789494&"
import script from "./DeleteRewardModal.vue?vue&type=script&lang=js&"
export * from "./DeleteRewardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports